import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import AdminHome from "./modules/backoffice/AdminHome";
import SalesHome from "./modules/backoffice/SalesHome";
import StaffHome from "./modules/backoffice/StaffHome";
import { Header } from './modules/common/Header';
import { Footer } from './modules/common/Footer';
import { LanguageProvider } from "./contexts/LanguageContext";
import ForgotPassword from "./modules/common/ForgotPassword";
import LoginPage from "./modules/common/Login";
import RequireAuth from "./modules/common/RequireAuth";
import PreventBackButton from "./modules/common/PreventBackButton";
import { AuthProvider } from "./modules/Contexts/AuthContext";
import RegisteredHospitals from "./modules/backoffice/Clinics/RegisteredHospitals"
import HospitalDetails from "./modules/backoffice/Clinics/HospitalDetails"
import VendorRegistration from "./modules/vendor/VendorRegistration";

import RegistrationSuccess from "./modules/vendor/RegistrationSuccess";
import img from "./assets/images/felixacare/ac_logo.png";
import ServiceCatalogue from "./modules/backoffice/Catalogue/ServiceCatalogue";
import MasterBanners from "./modules/backoffice/Banners/MasterBanners";
import VendorRevenue from "./modules/backoffice/Revenue/VendorRevenue";
import VendorDetails from "./modules/backoffice/Revenue/VendorDetails";
import VendorLiabilities from "./modules/backoffice/Liability/VendorLiabilities";

function AppContent() {

  useEffect(() => {
    const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.setAttribute("href", img);
    }
  }, []);
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Header />
        <div className="test" style={{ padding: "1%" }}>
          <Routes>
            {/* <Route path="/" element={<Home />} /> */}
            <Route path="/" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/vendor-register" element={<VendorRegistration />} />
            <Route path="/success" element={<RegistrationSuccess />} />
            <Route path="/config_admin" element={
              <RequireAuth allowedRoles={['config_admin']}>
                <PreventBackButton />
                <AdminHome />
              </RequireAuth>
            } />
            <Route exact path="/sales_admin" element={
              <RequireAuth allowedRoles={['sales_admin']}>
                <PreventBackButton />
                <SalesHome />
              </RequireAuth>
            } />
            <Route exact path="/staff" element={
              <RequireAuth allowedRoles={['staff']}>
                <PreventBackButton />
                <StaffHome />
              </RequireAuth>
            } />
            <Route path="/hospitallist" element={
              <RequireAuth allowedRoles={['staff', 'sales_admin', 'config_admin']}>
                <RegisteredHospitals />
              </RequireAuth>
            } />
            <Route path="/hospital-details/:id" element={
              <RequireAuth allowedRoles={['staff', 'sales_admin', 'config_admin']}>
                <HospitalDetails />
              </RequireAuth>
            } />
            <Route path="/servicecatalogue" element={
              <RequireAuth allowedRoles={['staff', 'sales_admin', 'config_admin']}>
                <ServiceCatalogue />
              </RequireAuth>
            } />
            <Route path="/master-banners" element={
              <RequireAuth allowedRoles={['staff', 'sales_admin', 'config_admin']}>
                <MasterBanners />
              </RequireAuth>
            } />
            <Route path="/revenue" element={
              <RequireAuth allowedRoles={['staff', 'sales_admin', 'config_admin']}>
                <VendorRevenue />
              </RequireAuth>
            } />
            <Route path="/vendor-revenue/:id" element={
              <RequireAuth allowedRoles={['staff', 'sales_admin', 'config_admin']}>
                <VendorDetails />
              </RequireAuth>
            } />
            <Route path="/liability" element={
              <RequireAuth allowedRoles={['staff', 'sales_admin', 'config_admin']}>
                <VendorLiabilities />
              </RequireAuth>
            } />
          </Routes>

        </div>

        <Footer />
      </BrowserRouter>
    </LanguageProvider >
  );
}
function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
export default App;